
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm14-.243V15.6h4.452c.396 0 .748-.237.748-.803V9.6s-4.075 2.785-4.054 2.779c-.024.013-.157.082-.269-.002l-.877-.62zm0-.811V8h4.719c.173 0 .481.253.481.607l-4.134 2.987a.228.228 0 01-.106 0l-.96-.648zM5.2 6.423v11.02l8.4 1.757V4.8L5.2 6.423zm5.62 7.372c-.354.467-.817.7-1.388.7-.557 0-1.01-.226-1.36-.677-.35-.453-.526-1.041-.526-1.767 0-.766.178-1.386.534-1.86.356-.473.827-.71 1.414-.71.555 0 1.003.227 1.345.68.343.453.514 1.05.514 1.792 0 .762-.177 1.376-.532 1.842zM9.42 10.4c-.312 0-.56.147-.744.44-.184.294-.276.683-.276 1.167 0 .491.092.88.276 1.165.184.286.425.428.723.428.307 0 .55-.139.73-.416.18-.278.271-.664.271-1.156 0-.514-.087-.914-.262-1.2-.175-.285-.414-.428-.717-.428z","fill":"currentColor"}})])
          )
        }
      }
    